import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useEbookUrl from '../hooks/useEbookUrl';

const PdfViewerNative: React.FC = () => {
    const { type, id } = useParams<{ type: string; id: string }>();
    const { i18n } = useTranslation();
    const isAr = i18n.language === 'ar';
    // Lien signé délivré par l'API (abonnés payants) — #101 : essai gratuit → abonnement
    const { url: pdfUrl, status } = useEbookUrl(type, id, isAr ? 'ar' : 'fr');

    if (status === 'login') {
        return <Navigate to={`/${i18n.language}/login`} replace />;
    }
    if (status === 'trial') {
        return <Navigate to={`/${i18n.language}/dashboard/subscription`} replace state={{ trialBlocked: true }} />;
    }

    if (status === 'loading') {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 70px)', background: '#525659' }}>
                <div className="spinner-border text-light" style={{ width: '3rem', height: '3rem' }}></div>
            </div>
        );
    }

    if (status === 'notfound' || !pdfUrl) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 70px)', background: '#525659', color: 'white' }}>
                <i className="bi bi-exclamation-triangle-fill text-warning" style={{ fontSize: '3rem' }}></i>
                <h5 className="mt-3">{isAr ? 'الملف غير موجود' : 'Fichier introuvable'}</h5>
            </div>
        );
    }

    return (
        <div style={{ height: 'calc(100vh - 70px)', width: '100%' }}>
            <iframe
                src={pdfUrl}
                style={{ width: '100%', height: '100%', border: 'none' }}
                title="PDF Viewer"
            />
        </div>
    );
};

export default PdfViewerNative;
